import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'cc-percent',
  templateUrl: './percent.component.html',
  styleUrls: ['./percent.component.scss']
})
export class PercentComponent {
  @Input() increasePositiveSentiment = true;
  @Input() results = new Observable();
  public isNaN: Function = Number.isNaN;
}
